<script lang="ts" generics="T extends { feature: CityFeaturePreview }">
	import type { KeepExploringCategory } from '$lib/api/velatlas/response.types';
	import KeepExploringSection from '$lib/components/ui/section/KeepExploringSection.svelte';
	import type { PlaceLocation } from '$lib/features/_other/placeLocation';
	import type { CityFeaturePreview } from '$lib/features/cityFeature/cityFeature.type';
	import type { Snippet } from 'svelte';

	const {
		spotlightItems,
		otherItems,
		keepExploring,
		location,
		HeaderSnippet,
		InfoSectionSnippet,
		SpotlightItemSnippet,
		OtherItemSnippet
	}: {
		spotlightItems: T[];
		otherItems: T[];
		keepExploring: KeepExploringCategory[];
		location: PlaceLocation;
		InfoSectionSnippet?: Snippet;
		HeaderSnippet: Snippet;
		SpotlightItemSnippet: Snippet<[item: T, index: number]>;
		OtherItemSnippet: Snippet<[item: T]>;
	} = $props();
</script>

{@render HeaderSnippet()}

<div class="container mx-auto px-4 py-14 md:py-16 lg:px-0">
	{#if spotlightItems.length > 0}
		<ul class="mb-12 flex flex-col gap-16 lg:mb-18">
			{#each spotlightItems as item, i (item.feature.id)}
				<li>
					{@render SpotlightItemSnippet(item, i)}
				</li>
			{/each}
		</ul>
	{/if}

	{#if otherItems.length > 0}
		<ul class="grid grid-cols-1 gap-8 md:grid-cols-2 lg:grid-cols-3">
			{#each otherItems as item (item.feature.id)}
				<li>
					{@render OtherItemSnippet(item)}
				</li>
			{/each}
		</ul>
	{/if}

	{#if InfoSectionSnippet}
		{@render InfoSectionSnippet()}
	{/if}

	<KeepExploringSection categories={keepExploring} {location} />
</div>
